// const ntxMenu = [
//   {
//     System: 'NTX',
//     isActive: false,
//     menu: [
//       { is_header: true, title: 'GeneralSystem', isActive: true },
//       {
//         path: '/SystemDashboard',
//         icon: 'fas fa-home',
//         title: 'HomePage',
//         isActive: true
//       },

//       { is_header: true, title: 'OrganizationalUnits', isActive: true },
//       {
//         path: '/Org/Organizations',
//         title: 'OrganizationalUnits',
//         icon: 'bi bi-buildings',
//         permission: 'ListHrDepartments',
//         isActive: true
//       },
//       {
//         path: '/Org/OrganizationStructure',
//         title: 'OrganizationalStructure',
//         icon: 'bi bi-diagram-3',
//         permission: 'ViewStructureHrDepartments',
//         isActive: true
//       },

//       { is_header: true, title: 'Lists&Forms', isActive: true },

//       {
//         path: '/Forms/ExtraInformationForm',
//         icon: 'bi bi-file-earmark-text',
//         title: 'ExtraInfoForm',
//         permission: 'NtxViewExtraInformation',
//         isActive: true
//       },

//       {
//         path: '/Forms/ExtraRecordsForm',
//         icon: 'bi bi-file-earmark-post',
//         title: 'ExtraRecordForm',
//         permission: 'NtxViewExtraInformationRecord',
//         isActive: true
//       },
//       {
//         path: '/Forms/LookupWithDynamic',
//         icon: 'bi bi-tags',
//         title: 'DataTypesForms',
//         permission: 'NtxViewSystemlistD',
//         isActive: true
//       },

//       {
//         path: '/NTX/ListSystem',
//         icon: 'bi bi-layers',
//         title: 'SystemLists',
//         permission: 'NtxViewSystemlistD',
//         isActive: true
//       },

//       {
//         path: '/NTX/Lookup',
//         icon: 'bi bi-search',
//         title: 'GeneralSystemLists',
//         permission: 'NtxViewgeneralsystemList',
//         isActive: true
//       },
//       // تصنيف إدارة المستخدمين
//       { is_header: true, title: 'UserManagement', isActive: true },
//       {
//         path: '/Security/Users',
//         icon: 'bi bi-person',
//         title: 'users',
//         permission: 'NtxViewuserslist',
//         isActive: true
//       },

//       {
//         path: '/Security/AuthRules',
//         icon: 'bi bi-shield-lock',
//         title: 'RulesPermissions',
//         permission: 'NtxViewlistpermissionsRule',
//         isActive: true
//       },

//       { is_header: true, title: 'Settings', isActive: true },
//       {
//         path: '/Pay/Banks',
//         icon: 'fas fa-university',
//         title: 'Banks',
//         permission: 'listHrPerBank',
//         isActive: true
//       },
//       {
//         path: '/Finance/Ap/Currencies',
//         icon: 'fas fa-globe',
//         title: 'Currencies',
//         isActive: true
//       },
//       {
//         path: '/Neatix/Settings',
//         icon: 'bi bi-gear', // ⚙️ أيقونة الإعدادات
//         title: 'Settings',
//         isActive: true
//       },

//       { is_header: true, title: 'Applications', isActive: true },
//       {
//         path: '/NTX/Apps',
//         icon: '/bi bi-grid', //
//         title: 'Applications',
//         isActive: true
//       }

//     ]
//   }
// ];

// export default ntxMenu;

const ntxMenu = [
  {
    System: 'NTX',
    isActive: true,
    menu: [
      // 🏠 النظام العام
      { is_header: true, title: 'GeneralSystem', isActive: true },
    
         {
        path: '/NTX/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },


      // 🏢 الوحدات التنظيمية
      { is_header: true, title: 'OrganizationalUnits', isActive: true },
      {
        path: '/NTX/Organizations',
        title: 'OrganizationalUnits',
        icon: 'bi bi-buildings',
        // permission: 'ListHrDepartments',
        isActive: true
      },
      {
        path: '/NTX/OrganizationStructure',
        title: 'OrganizationalStructure',
        icon: 'bi bi-diagram-3',
        // permission: 'ViewStructureHrDepartments',
        isActive: true
      },

      // 📋 النماذج والقوائم
      { is_header: true, title: 'Lists&Forms', isActive: true },
      {
        path: '/NTX/ExtraInformationForm',
        icon: 'bi bi-file-earmark-text',
        title: 'ExtraInfoForm',
        permission: 'NtxViewExtraInformation',
        isActive: true
      },
      {
        path: '/NTX/ExtraRecordsForm',
        icon: 'bi bi-file-earmark-post',
        title: 'ExtraRecordForm',
        permission: 'NtxViewExtraInformationRecord',
        isActive: true
      },
      {
        path: '/NTX/LookupWithDynamic',
        icon: 'bi bi-tags',
        title: 'DataTypesForms',
        permission: 'NtxViewSystemlistD',
        isActive: true
      },
      {
        path: '/NTX/ListSystem',
        icon: 'bi bi-layers',
        title: 'SystemLists',
        permission: 'NtxViewSystemlistD',
        isActive: true
      },
      {
        path: '/NTX/Lookup',
        icon: 'bi bi-search',
        title: 'GeneralSystemLists',
        permission: 'NtxViewgeneralsystemList',
        isActive: true
      },

      // 👥 إدارة المستخدمين
      { is_header: true, title: 'UserManagement', isActive: true },
      {
        path: '/NTX/Users',
        icon: 'bi bi-person',
        title: 'users',
        permission: 'NtxViewuserslist',
        isActive: true
      },
      {
        path: '/NTX/AuthRules',
        icon: 'bi bi-shield-lock',
        title: 'RulesPermissions',
        permission: 'NtxViewlistpermissionsRule',
        isActive: true
      },

      // ⚙️ الإعدادات العامة
      { is_header: true, title: 'Settings', isActive: true },
      {
        path: '/NTX/Banks',
        icon: 'fas fa-university',
        title: 'Banks',
        permission: 'listHrPerBank',
        isActive: true
      },
      {
        path: '/NTX/Currencies',
        icon: 'fas fa-globe',
        title: 'Currencies',
        isActive: true
      },
      {
        path: '/NTX/DailyRates',
        title: 'DailyRates',
        icon: 'bi bi-arrow-repeat',
        isActive: true
      },
      {
        path: '/NTX/Settings',
        icon: 'bi bi-gear',
        title: 'Settings',
        isActive: true
      },

      // 🧩 التطبيقات
      { is_header: true, title: 'Applications', isActive: true },
      {
        path: '/NTX/Apps',
        icon: 'bi bi-grid',
        title: 'Applications',
        isActive: true
      }
    ]
  }
];

export default ntxMenu;
